import { WarningFilled } from '@ant-design/icons';
import { FlexRow } from '@framework/ui';
import { Space } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

export const PaymentRowWidgetContainerWrapper = styled.div`
  border: 3px solid ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadius}px;
  transition: border-color 0.2s ease-in-out;
  &.included {
    border-color: ${props => props.theme.colorPrimary};
  }
  margin-bottom: 24px;
`;
export const LeftColWrapper = styled.div`
  border-radius: ${props => props.theme.borderRadius - 3}px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.theme.colorBorder};
  padding: 8px;
  padding-right: 3px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease-in-out;
  &.included {
    background-color: ${props => props.theme.colorPrimary};
  }
`;
export const ReportWrapper = styled.div`
  opacity: 0.7;
  transition: opacity 0.2s ease-in-out;
  &.included {
    opacity: 1;
  }
`;

const LeftIconLockWrapper = styled.div`
  color: ${props => props.theme.colorBgContainer};
  margin-inline-end: 8px;
`;
const IconWarningWrapper = styled.div`
  color: ${props => props.theme.colorWarningTextActive};
`;
const PaymentRowWidgetContentWrapper = styled.div`
  padding: 16px;
  padding-bottom: 8px;
`;

export interface IPaymentRowWidgetContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  included?: boolean;
  canBeExcluded?: boolean;
  left?: React.ReactNode;
  report?: React.ReactNode;
}

export function PaymentRowWidgetContainer(
  props: IPaymentRowWidgetContainerProps,
) {
  const { children, included, left, canBeExcluded, report } = props;

  return (
    <PaymentRowWidgetContainerWrapper className={clx({ included })}>
      <FlexRow
        align="stretch"
        left={
          <LeftColWrapper className={clx({ included })}>
            {canBeExcluded ? (
              left
            ) : (
              <LeftIconLockWrapper>
                <div style={{ minWidth: '16px' }} />
              </LeftIconLockWrapper>
            )}
          </LeftColWrapper>
        }
      >
        <PaymentRowWidgetContentWrapper>
          <div>{children}</div>
          <div>
            <FlexRow
              right={
                <ReportWrapper className={clx({ included })}>
                  {report}
                </ReportWrapper>
              }
            >
              <div style={{ marginTop: -12, lineHeight: 1.2 }}>
                {!included && (
                  <Space align="center" size={4}>
                    <IconWarningWrapper>
                      <WarningFilled />
                    </IconWarningWrapper>
                    {/* // TODO Traduzioni */}
                    <div>Questa voce di costo non è inclusa nel pagamento.</div>
                  </Space>
                )}
              </div>
            </FlexRow>
          </div>
        </PaymentRowWidgetContentWrapper>
      </FlexRow>
    </PaymentRowWidgetContainerWrapper>
  );
}
